/** Mailto uses all brace markers; the rich clipboard keeps its own parser. */
export function composeSharedSpaceEmailBody(
  body: string,
  link: string,
): string {
  const marker = /\{\{\s*link\s*\}\}/gi;
  return marker.test(body)
    ? body.replace(marker, () => link)
    : `${body}\n\n${link}`;
}
